import React from 'react'
import { useParams } from 'react-router-dom';
import Viewjob from '../Viewjob';
import Createjob from './create/Createjob';

const JobPage = () => {
    const urlParams = useParams();
    return (urlParams.id === 'create' ? <Createjob /> : <Viewjob jobId={urlParams.id} />)
}

export default JobPage